<div class="loading-animate">&nbsp;</div>
<div class="page">
  <app-header></app-header>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
</div>
<app-banner-modal></app-banner-modal>